/* EBH — favoritos sem app (2026-09-12)
   ---------------------------------------------------------------------------
   Substitui o módulo Wishlist da Vitals. A lista vive no navegador de quem
   visita, em localStorage.

   ⚠️ O registo é escrito NO MOMENTO em que o coração é carregado, e leva já o
      título, a cor, o hexadecimal, a imagem e o preço do dia. É de propósito:
      só o Liquid do cartão sabe o hex da cor (vem do metaobjecto color-pattern
      ou de `custom.cores_irmas`, e nenhum dos dois chega ao /products/x.js).
      A página de favoritos confirma preço e stock depois, mas nasce já pintada.

   ⚠️ `preco_guardado` é o que permite dizer «baixou de preço». Sem ele não há
      como saber que desceu — não se apaga ao actualizar o preço corrente.

   ⚠️ Páginas servidas pela CDN vêm sempre iguais para toda a gente: os corações
      TÊM de ser acesos aqui, do lado do cliente, nunca em Liquid.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var KEY = 'ebh:wishlist:v1';
  var VIEW_KEY = 'ebh:wishlist:view';
  var MAX = 200;

  /* O que se guarda é um ESTADO, não uma lista: as peças e as lápides.
     Uma lápide é o instante em que uma peça foi tirada. Sem elas, tirar uma
     peça no telemóvel deixava-a voltar do computador na fusão seguinte — por
     união simples a peça existe num dos lados e volta sempre. */
  /* localStorage atira em navegação privada e com cookies bloqueados — nunca
     deixar isso partir a página: sem sítio para guardar, a lista fica vazia. */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return { lista: [], lapides: {} };
      var v = JSON.parse(raw);
      if (Array.isArray(v)) return { lista: v, lapides: {} };   // formato antigo
      return { lista: Array.isArray(v.lista) ? v.lista : [], lapides: v.lapides || {} };
    } catch (e) {
      return { lista: [], lapides: {} };
    }
  }

  function write(estado) {
    estado.lista = estado.lista.slice(0, MAX);
    try {
      window.localStorage.setItem(KEY, JSON.stringify(estado));
    } catch (e) {
      /* cheio ou bloqueado: a lista desta sessão continua a funcionar */
    }
    document.dispatchEvent(new CustomEvent('ebh:wishlist:change', { detail: { estado: estado } }));
  }

  function indexOf(lista, handle) {
    for (var i = 0; i < lista.length; i++) {
      if (lista[i] && lista[i].handle === handle) return i;
    }
    return -1;
  }

  var WL = {
    KEY: KEY,
    VIEW_KEY: VIEW_KEY,

    estado: function () { return read(); },
    all: function () { return read().lista; },
    count: function () { return read().lista.length; },
    has: function (handle) { return indexOf(read().lista, handle) !== -1; },

    /* Substitui o estado inteiro — é por aqui que entra o que veio do servidor. */
    poe: function (estado) {
      write({ lista: (estado && estado.lista) || [], lapides: (estado && estado.lapides) || {} });
    },

    add: function (rec) {
      if (!rec || !rec.handle) return false;
      var e = read();
      if (indexOf(e.lista, rec.handle) !== -1) return false;
      rec.guardado_em = Date.now();
      delete e.lapides[rec.handle];   // guardar outra vez levanta a lápide
      e.lista.unshift(rec);           // o mais recente à cabeça: é o que fica grande no mosaico
      write(e);
      return true;
    },

    remove: function (handle) {
      var e = read();
      var i = indexOf(e.lista, handle);
      e.lapides[handle] = Date.now();  // a lápide grava-se mesmo que a peça já cá não esteja
      if (i !== -1) e.lista.splice(i, 1);
      write(e);
      return i !== -1;
    },

    toggle: function (rec) {
      return this.has(rec.handle) ? (this.remove(rec.handle), false) : (this.add(rec), true);
    },

    /* Preferência de vista (mosaico|lista). Sem escolha feita, o telemóvel
       abre na lista: o mosaico a quatro colunas não cabe num ecrã estreito. */
    view: function () {
      var v;
      try { v = window.localStorage.getItem(VIEW_KEY); } catch (e) { v = null; }
      if (v === 'mosaico' || v === 'lista') return v;
      return window.matchMedia('(max-width: 768px)').matches ? 'lista' : 'mosaico';
    },

    setView: function (v) {
      try { window.localStorage.setItem(VIEW_KEY, v); } catch (e) {}
    }
  };

  window.EBHWishlist = WL;

  /* ---------------------------------------------------------------- corações */

  function recordFrom(btn) {
    return {
      handle: btn.dataset.wlHandle,
      preco_guardado: parseInt(btn.dataset.wlPrice || '0', 10) || 0,
      disponivel_visto: true
    };
  }

  function paint(btn, on) {
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? btn.dataset.wlLabelOn : btn.dataset.wlLabelOff;
    if (label) { btn.setAttribute('aria-label', label); btn.setAttribute('title', label); }
    /* Na ficha o coração tem palavra ao lado: acender o desenho e deixar lá
       «Guardar» dizia o contrário do que o botão já tinha feito. */
    var t = btn.querySelector('[data-wl-text-off]');
    if (t) t.textContent = on ? t.dataset.wlTextOn : t.dataset.wlTextOff;
  }

  function hydrate(root) {
    var lista = read().lista;
    (root || document).querySelectorAll('[data-wl-handle]').forEach(function (btn) {
      paint(btn, indexOf(lista, btn.dataset.wlHandle) !== -1);
    });
  }

  function paintCount() {
    var n = read().lista.length;
    document.querySelectorAll('[data-ebh-wl-count]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      el.classList.toggle('is-on', n > 0);
    });
  }

  /* Delegação no documento: os cartões nascem e morrem com os filtros, a
     paginação infinita e a compra rápida — prender o clique a cada botão
     deixava de fora tudo o que aparecesse depois. */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-wl-handle]');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();          // dentro do cartão, o pai é a ligação para o produto
    var on = WL.toggle(recordFrom(btn));
    paint(btn, on);
  });

  document.addEventListener('ebh:wishlist:change', function () {
    hydrate();
    paintCount();
  });

  function start() { hydrate(); paintCount(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Duas janelas abertas na mesma loja: a segunda tem de ver o que a primeira
     guardou. O evento `storage` só dispara nas OUTRAS janelas, nunca na própria. */
  window.addEventListener('storage', function (ev) {
    if (ev.key === KEY) start();
  });

  /* Filtros e paginação do tema trocam a grelha por dentro sem recarregar. */
  ['ebh:filtros:atualizado', 'shopify:section:load'].forEach(function (name) {
    document.addEventListener(name, function () { hydrate(); });
  });
})();
